<template>
  <img v-if="src"
    :class="$options.name"
    :src="src"
    :alt="alt"
    :style="{ transform: `scale(${scale})` }" />
</template>

<script>
export default {
  name: 'brand-logo',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    scale: { type: Number, default: 1 },
  }
}
</script>

<style scoped>
.brand-logo {
  max-height: 32rem;
  max-width: 80rem;
  object-fit: contain;
  transform-origin: center;
}
</style>
